import HTTP from '@/utils/http-common';

const listTeams = async () => (await HTTP.get('/teams')).data;
const createTeam = async (team) => (await HTTP.post('/teams', team)).data;
const updateTeam = async (id, team) => (await HTTP.put(`/teams/${id}`, team)).data;
const archiveTeam = async (id) => (await HTTP.put(`/teams/${id}/archive`, {})).data;
const saveTeam = (team) => (team._id ? updateTeam(team._id, team) : createTeam(team));
const getOrderScope = async () => (await HTTP.get('/teams/order-scope')).data;

export { listTeams, createTeam, updateTeam, archiveTeam, saveTeam, getOrderScope };
